import { MODE_3D_VIEW } from '@constants'
import { ThreeEvent } from '@react-three/fiber'
import { useAppStore } from '@store'
import toQuaternion from '@utils/conversion/toQuaternion'
import { toVector3 } from '@utils/conversion/toVector3'
import { useState } from 'react'
import { Euler, Matrix4 } from 'three'

export function useLightEvents3D(id: string) {
  const select = useAppStore.use.select()
  const mode = useAppStore.use.mode()
  const editItem = useAppStore.use.editItem()
  const unselectAll = useAppStore.use.unselectAll()
  const isModalOpen = useAppStore.use.isModalOpen()
  const [gizmoVisible, setGizmoVisible] = useState(false)

  function handleClick(e: ThreeEvent<MouseEvent>) {
    if (isModalOpen) return
    e.stopPropagation()

    unselectAll()
    setGizmoVisible(true)
    if (mode === MODE_3D_VIEW) {
      select(id, false)
    }
  }

  function handleDrag(w: Matrix4) {
    if (isModalOpen) return
    const position = toVector3()
    const rotation = toQuaternion()
    w.decompose(position, rotation, toVector3())

    // Extraer la rotación en grados del eje Y (yaw)
    const euler = new Euler().setFromQuaternion(rotation, 'YXZ')
    const rotationDegrees = euler.y * (180 / Math.PI)

    // Normalizar la rotación a 0-360
    const normalizedRotation = ((rotationDegrees % 360) + 360) % 360

    editItem(id, {
      y: position.y,
      matrix: w.clone(),
      rotation: normalizedRotation,
    })
  }

  function handleDragStart() {
    if (isModalOpen) return
    unselectAll()
    select(id, false)
    setGizmoVisible(true)
  }

  function handleDragEnd() {
    if (isModalOpen) return
    setGizmoVisible(false)
  }

  return { handleClick, handleDrag, handleDragStart, handleDragEnd, gizmoVisible }
}
